import { hideModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";
import { ContainerModalAtencionSinTurno } from "./localStyle";

const ModalTurnoParticular = ({ tomarTurno, osAlternativa, mensajeError }) => {
  const { modalDispatch } = useContext(GlobalContext);
  const handleTomarTurno = () => {
    tomarTurno();
    hideModal()(modalDispatch);
  };

  return osAlternativa ? (
    <ContainerModalAtencionSinTurno>
    <span className="bold">¿Desea tomar el turno como su obra social alternativa?</span>
    <span>{mensajeError !== "" ? mensajeError : "El estudio seleccionado no figura dentro de tu cobertura"}</span>
    <div className="container-btn">
      <button className="cancelar" onClick={() => hideModal()(modalDispatch)}>
        Cancelar
      </button>
      <button className="tomar" onClick={handleTomarTurno}>
        Tomar como particular
      </button>
    </div>
  </ContainerModalAtencionSinTurno>
  ) : (
    <ContainerModalAtencionSinTurno>
      <span className="bold">¿Desea tomar el turno como particular?</span>
      <span>{mensajeError !== "" ? mensajeError : "El estudio seleccionado no figura dentro de tu cobertura"}</span>
      <div className="container-btn">
        <button className="cancelar" onClick={() => hideModal()(modalDispatch)}>
          Cancelar
        </button>
        <button className="tomar" onClick={handleTomarTurno}>
          Tomar como particular
        </button>
      </div>
    </ContainerModalAtencionSinTurno>
  );
};
export default ModalTurnoParticular;
